// extracted by mini-css-extract-plugin
export var bold = "_rg-0";